"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = void 0;
const isEmpty = (array) => !array || !array.length;
exports.isEmpty = isEmpty;
//# sourceMappingURL=isEmpty.js.map